<div class="city-page-wrapper">
  <dx-load-panel
    [hideOnOutsideClick]="false"
    shadingColor="rgba(0,0,0,0.4)"
    [(visible)]="loading"
  >
  </dx-load-panel>
  <div class="page-wrapper">
    <div class="container-fluid">
      <form [formGroup]="salesInquiryForm">
        <app-panel [footer]="true" class="mb-3" [backArrow]="false" [showPanel]="collapse">
          <div class="heading">Filters</div>
          <div class="body">
            <div class="row">
              <div class="col-md-3">
                <div class="text-left">Branch:</div>
                <div class="dx-field">
                  <dx-tag-box
                    [inputAttr]="{ autocomplete: 'off' }"
                    [items]="branchList"
                    placeholder="Select Branch"
                    [showClearButton]="true"
                    displayExpr="customerBranchName"
                    valueExpr="customerBranchId"
                    formControlName="companyBranchId"
                    [searchEnabled]="true"
                    [tabIndex]="1"
                  >
                  </dx-tag-box>
                </div>
              </div>
              <div class="col-md-3">
                <div class="dx-field">
                  <kendo-formfield>
                    <kendo-label
                      [for]="customerBranchId"
                      text="Customer Name *"
                    ></kendo-label>
                    <kendo-combobox
                      [virtual]="true"
                      [clearButton]="true"
                      #customerBranchId
                      class="w-100"
                      [loading]="loadingCustomer"
                      formControlName="customerBranchId"
                      [valuePrimitive]="true"
                      [data]="customerList"
                      [valueField]="'customerBranchId'"
                      [textField]="'customerName'"
                      [filterable]="true"
                      [kendoDropDownFilter]="{ operator: 'contains' }"
                      [suggest]="true"
                      [tabIndex]="2"
                      [placeholder]="'Choose Customer Name'"
                    >
                    </kendo-combobox>
                  </kendo-formfield>
                </div>
              </div>
              <div class="col-md-3">
                <div class="text-left">Sales Order #:</div>
                <div class="dx-field">
                  <dx-number-box
                    [inputAttr]="{ autocomplete: 'off' }"
                    formControlName="salesOrderNo"
                    [tabIndex]="3"
                    [showSpinButtons]="false"
                    [step]="0"
                    type="text"
                    placeholder="Enter SO #..."
                  >
                  </dx-number-box>
                </div>
              </div>
              <div class="col-md-3">
                <div class="text-left">Brand:</div>
                <div class="dx-field">
                  <dx-select-box
                    [inputAttr]="{ autocomplete: 'off' }"
                    [items]="brandMasterList"
                    placeholder="Select Brand"
                    [showClearButton]="true"
                    displayExpr="brandName"
                    valueExpr="brandMasterId"
                    [searchEnabled]="true"
                    formControlName="brandId"
                    [tabIndex]="4"
                  >
                  </dx-select-box>
                </div>
              </div>
              <!-- <div class="col-md-3">
                <div class="text-left">Sub Brand:</div>
                <div class="dx-field">
                  <dx-select-box
                    [inputAttr]="{ autocomplete: 'off' }"
                    [items]="subBrandList"
                    [readOnly]="subBrandList?.length == 0"
                    placeholder="Select Sub Brand"
                    [showClearButton]="true"
                    displayExpr="subBrandName"
                    valueExpr="subBrandMasterId"
                    formControlName="subBrandId"
                    [searchEnabled]="true"
                    [tabIndex]="5"
                  >
                  </dx-select-box>
                </div>
              </div> -->
              <div class="col-md-3">
                <div class="text-left">Order Type:</div>
                <div class="dx-field">
                  <dx-select-box
                    [inputAttr]="{ autocomplete: 'off' }"
                    [items]="orderTypeList"
                    placeholder="Select Order Type"
                    [showClearButton]="true"
                    displayExpr="salesOrderTypeName"
                    valueExpr="salesOrderTypeId"
                    formControlName="orderTypeId"
                    [searchEnabled]="true"
                    [tabIndex]="6"
                  >
                  </dx-select-box>
                </div>
              </div>
              <!-- <div class="col-md-3">
                <div class="text-left">Result:</div>
                <div class="dx-field">
                  <dx-select-box
                    [inputAttr]="{ autocomplete: 'off' }"
                    [items]="resultList"
                    placeholder="Select Result"
                    [showClearButton]="true"
                    displayExpr="resultName"
                    valueExpr="resultId"
                    formControlName="resultId"
                    [searchEnabled]="true"
                    [tabIndex]="7"
                  >
                  </dx-select-box>
                </div>
              </div> -->
              <!-- <div class="col-md-4">
              <div class="text-left">Cancel Order:</div>
              <div class="dx-field">
                <dx-select-box [inputAttr]="{ autocomplete: 'off' }" 
                  [items]="cancelOrderList"
                  placeholder="Select Cancel Order"
                  [showClearButton]="true"
                  displayExpr="cancelOrderName"
                  valueExpr="cancelOrderId"
                  formControlName="cancelOrderId"
                  [searchEnabled]="true">
                </dx-select-box>
              </div>
            </div> -->

              <!-- <div class="col-md-4">
              <div class="text-left">From Date:</div>
              <div class="dx-field">
                <dx-date-box type="date" formControlName="fromDate" style="width: 100%">
                </dx-date-box>
              </div>
            </div>
            <div class="col-md-4">
              <div class="text-left">To Date:</div>
              <div class="dx-field">
                <dx-date-box type="date" formControlName="toDate" style="width: 100%">
                </dx-date-box>
              </div>
            </div> -->

              <div class="col-md-3">
                <div class="dx-field">
                  <div>Date From:</div>
                  <dx-date-box
                  type="date"
                  displayFormat="dd/MMM/yyyy"
                  formControlName="fromDate"
                    style="width: 100%"
                    (onValueChanged)="onValueChanged1($event)"
                    [readOnly]="
                      !salesInquiryForm.get('includeDateFilter').value
                    "
                    [tabIndex]="8"
                  >
                    <dx-validator (onInitialized)="onInitialized1($event)">
                      <dxi-validation-rule
                        type="custom"
                        message="From date must come before to date"
                        [validationCallback]="dateValidation"
                        [reevaluate]="true"
                      ></dxi-validation-rule>
                    </dx-validator>
                  </dx-date-box>
                </div>
              </div>
              <div class="col-md-3">
                <div class="dx-field">
                  <div>Date To:</div>
                  <dx-date-box
                  type="date"
                  displayFormat="dd/MMM/yyyy"
                  formControlName="toDate"
                    style="width: 100%"
                    (onValueChanged)="onValueChanged2($event)"
                    [readOnly]="
                      !salesInquiryForm.get('includeDateFilter').value"
                    [tabIndex]="9"
                  >
                    <dx-validator (onInitialized)="onInitialized2($event)">
                      <dxi-validation-rule
                        type="custom"
                        message="To date must come before from date"
                        [validationCallback]="dateValidation"
                        [reevaluate]="true"
                      ></dxi-validation-rule>
                    </dx-validator>
                  </dx-date-box>
                </div>
              </div>
              <div class="col-md-3">
                <div class="text-left">PO #:</div>
                <div class="dx-field">
                  <dx-text-box
                    [inputAttr]="{ autocomplete: 'off' }"
                    formControlName="poNumber"
                    [tabIndex]="9"
                    type="text"
                    placeholder="Enter PO #..."
                  >
                  </dx-text-box>
                </div>
              </div>
              <!-- <div class="col-md-3">
                <div class="dx-field">
                  <kendo-formfield>
                    <kendo-label
                      [for]="sph"
                      text="SPH"
                    ></kendo-label>
                    <kendo-combobox
                      [virtual]="true"
                      [clearButton]="false"
                      #sph
                      class="w-100"
                      [loading]="loadingSphRange"
                      formControlName="sph"
                      [valuePrimitive]="true"
                      [data]="sphRangeList"
                      [valueField]="'sphValue'"
                      [textField]="'sphValue'"
                      [filterable]="true"
                      [kendoDropDownFilter]="{ operator: 'contains' }"
                      [suggest]="true"
                      [placeholder]="'SPH'"
                      [tabIndex]="10"
                    >
                    </kendo-combobox>
                  </kendo-formfield>
                </div>
              </div>
              <div class="col-md-3">
                <div class="dx-field">
                  <kendo-formfield>
                    <kendo-label
                      [for]="cyl"
                      text="CYL"
                    ></kendo-label>
                    <kendo-combobox
                      [virtual]="true"
                      [clearButton]="false"
                      #cyl
                      class="w-100"
                      [loading]="loadingCylRange"
                      formControlName="cyl"
                      [valuePrimitive]="true"
                      [data]="cylRangeList"
                      [valueField]="'cylValue'"
                      [textField]="'cylValue'"
                      [filterable]="true"
                      [kendoDropDownFilter]="{ operator: 'contains' }"
                      [suggest]="true"
                      [placeholder]="'CYL'"
                      [tabIndex]="11"
                    >
                    </kendo-combobox>
                  </kendo-formfield>
                </div>
              </div>
              <div class="col-md-3">
                <div class="dx-field">
                  <kendo-formfield>
                    <kendo-label
                      [for]="add"
                      text="ADD"
                    ></kendo-label>
                    <kendo-combobox
                      [virtual]="true"
                      [clearButton]="false"
                      #add
                      class="w-100"
                      [loading]="loadingAddfRange"
                      formControlName="add"
                      [valuePrimitive]="true"
                      [data]="addfRangeList"
                      [valueField]="'addfValue'"
                      [textField]="'addfValue'"
                      [filterable]="true"
                      [kendoDropDownFilter]="{ operator: 'contains' }"
                      [suggest]="true"
                      [placeholder]="'ADD'"
                      [tabIndex]="12"
                    >
                    </kendo-combobox>
                  </kendo-formfield>
                </div>
              </div> -->
              <!-- <div class="col-md-3">
                <div class="dx-field">
                  <kendo-formfield>
                    <kendo-label
                      [for]="active"
                      text="Active"
                    ></kendo-label>
                    <kendo-combobox
                      [virtual]="true"
                      [clearButton]="false"
                      #active
                      class="w-100"
                      formControlName="active"
                      [valuePrimitive]="true"
                      [data]="activeList"
                      [valueField]="'value'"
                      [textField]="'name'"
                      [filterable]="true"
                      [kendoDropDownFilter]="{ operator: 'contains' }"
                      [suggest]="true"
                      [placeholder]="'Active'"
                      [tabIndex]="13"
                    >
                    </kendo-combobox>
                  </kendo-formfield>
                </div>
              </div> -->
            </div>
          </div>
          <div class="footer">
            <div class="float-left mt-2">
              <div class="d-inline-block">
                Include Date Filter
                <dx-check-box
                  formControlName="includeDateFilter"
                ></dx-check-box>
              </div>
              <div class="d-inline-block ml-3" *ngIf="rows?.length">
                <span class="mr-2">Total Orders: {{ totalOrders }}</span>
                <span class="mr-2">Total Issued QTY: {{ totalIssuedQTY }}</span>
                <span>Total Order QTY: {{ totalOrderQTY }}</span>
              </div>
            </div>
            <div class="float-left ml-2">
                <mat-chip-listbox #chipList aria-label="Filter Data">
                    <mat-chip *ngFor="let item of chips" [selectable]="true"
                              [removable]="true" (removed)="remove(item)">
                        {{item.name}}
                        <mat-icon matChipRemove>cancel</mat-icon>
                    </mat-chip>
                </mat-chip-listbox>
            </div>
            <div class="float-right">
              <!-- <dx-button
                id="button"
                text="Order Transfer"
                type="default"
                class="mr-3"
                (click)="openOrderTransferPopup()"
              >
              </dx-button> -->
              <dx-button
                id="button"
                text="Reset Filter"
                type="default"
                class="mr-3"
                (click)="resetFilters()"
                [disabled]="loading"
              >
              </dx-button>
              <dx-button
                id="button"
                text="Filter"
                type="default"
                (click)="
                  !salesInquiryForm.valid ||
                    getSalesInquiryList(salesInquiryForm)
                "
                [useSubmitBehavior]="true"
                [disabled]="loading || !salesInquiryForm.valid || !salesInquiryForm.get('customerBranchId').value"
               >
              </dx-button>
            </div>
          </div>
        </app-panel>
      </form>
      <div class="mt-2 mb-2"></div>
      <!-- <div class="column filter-positions-sales-inquiry" *ngIf="temp?.length">
        <div class="flex-p">
          <dx-radio-group
            [items]="filterList"
            [value]="filterList[0]"
            layout="horizontal"
            (onValueChanged)="onRadioChecked($event.value)"
          >
          </dx-radio-group>
        </div>
      </div> -->
      <div class="row mt-5">
        <div class="col-md-12">
          <dx-data-grid
            id="gridContainer10"
            #salesInquiryGrid
            [dataSource]="rows"
            [wordWrapEnabled]="false"
            [hoverStateEnabled]="true"
            [columnAutoWidth]="true"
            [allowColumnResizing]="true"
            [columnResizingMode]="'widget'"
            [allowColumnReordering]="true"
            [showBorders]="true" (onExporting)="onExporting($event)" 
          >
            <dxo-load-panel [enabled]="true"></dxo-load-panel>
            <dxo-filter-row [visible]="true"></dxo-filter-row>
            <dxo-header-filter [visible]="true"></dxo-header-filter>
            <dxo-paging [pageSize]="15"></dxo-paging>
            <dxo-export
              [enabled]="true"
              fileName="AllProductionInquiry"
              [allowExportSelectedData]="false"
            ></dxo-export>
            <dxo-column-chooser
              [enabled]="true"
              mode="select"
            ></dxo-column-chooser>
            <dxo-pager
              [showPageSizeSelector]="false"
              [allowedPageSizes]="[15, 30, 40]"
              [showInfo]="true"
            ></dxo-pager>
            <dxo-group-panel [visible]="true"></dxo-group-panel>
            <dxo-grouping #expand [autoExpandAll]="true"></dxo-grouping>
            <dxi-column
              caption="Actions"
              [fixed]="true"
              [width]="100"
              cssClass="text-center"
              cellTemplate="cellTemplate"
              [allowFiltering]="false"
            ></dxi-column>
            <dxi-column
              dataField="customerName"
              [fixed]="true"
              caption="Customer Name"
              cssClass="text-left"
              [width]="200"
            ></dxi-column>
            <dxi-column
              dataField="salesOrderNo"
              [fixed]="true"
              caption="SO #"
              cssClass="text-center"
              [width]="50"
              cellTemplate="salesOrderNoTemplate"
            ></dxi-column>
            <dxi-column
              dataField="baseSalesOrderId"
              [visible]="false"
              [fixed]="true"
              caption="Ref.SO #"
              cssClass="text-center"
              [width]="100"
            ></dxi-column>
            <dxi-column
              dataField="salesOrderTypeName"
              [fixed]="true"
              caption="Type"
              cssClass="text-left"
              [width]="80"
            ></dxi-column>
            <dxi-column
              dataField="salesOrderDate"
              [fixed]="true"
              caption="Order Date"
              cssClass="text-left"
              [width]="80"
              [allowFiltering]="false"
            ></dxi-column>
            <dxi-column
              dataField="itemName"
              [fixed]="true"
              caption="Catalog"
              cssClass="text-left"
              [width]="200"
            ></dxi-column>
            <dxi-column
              dataField="brandName"
              [fixed]="true"
              caption="Brand"
              cssClass="text-left"
              [width]="120"
            ></dxi-column>
            <dxi-column
            dataField="focalCode"
            [fixed]="true"
            caption="Focal"
            cssClass="text-left"
            [width]="80"
          ></dxi-column>
            <!-- <dxi-column
              dataField="lensRefNo"
              caption="Lens Ref. NO (Lot #)"
              cssClass="text-left"
            ></dxi-column> -->
            <dxi-column
              dataField="side"
              caption="Side"
              cssClass="text-center"
            ></dxi-column>
            <dxi-column
              dataField="size"
              caption="Size"
              cssClass="text-center"
            ></dxi-column>
            <dxi-column
              dataField="holdStatus"
              caption="Hold"
              [width]="100"
            ></dxi-column>
            <dxi-column
              dataField="sph"
              caption="SPH"
              cssClass="text-center"
              cellTemplate="sphTemplate"
            ></dxi-column>
            <dxi-column
              dataField="cyl"
              caption="CYL"
              cssClass="text-center"
              cellTemplate="cylTemplate"
            ></dxi-column>
            <dxi-column
              dataField="axis"
              caption="AXIS"
              cssClass="text-center"
              cellTemplate="axisTemplate"
            ></dxi-column>
            <dxi-column
              dataField="add"
              caption="ADD"
              cssClass="text-center"
              cellTemplate="addTemplate"
            ></dxi-column>
            <dxi-column dataField="services" caption="Services"></dxi-column>
            <!-- <dxi-column
              dataField="unitPrice"
              caption="Price"
              cssClass="text-center"
            ></dxi-column> -->
            <dxi-column
              dataField="oQty"
              caption="O. QTY"
              cssClass="text-center"
              [width]="100"
            ></dxi-column>
            <dxi-column
              dataField="iQty"
              caption="I. QTY"
              cssClass="text-center"
              [width]="100"
            ></dxi-column>
            <!-- <dxi-column
              dataField="totalAmount"
              caption="Order Amount"
              cssClass="text-right"
              [width]="100"
            ></dxi-column> -->
            <dxi-column
              dataField="currentStatus"
              caption="Status"
              cssClass="text-left"
              cellTemplate="currentStatusTemplate"
            ></dxi-column>
            <dxi-column
              dataField="invoiceId"
              caption="Invoice #"
              cssClass="text-center"
              cellTemplate="invoiceIdTemplate"
            ></dxi-column>
            <dxi-column
              dataField="salesOrderComplainId"
              caption="Complaint #"
              cssClass="text-center"
            ></dxi-column>
            <dxi-column
              dataField="salesReturnId"
              caption="Return #"
              cssClass="text-center"
              cellTemplate="salesReturnIdTemplate"
            ></dxi-column>
            <dxi-column
              dataField="storeRemarks"
              caption="Store Remarks"
              cssClass="text-left"
            ></dxi-column>
            <dxi-column
              dataField="createdBy"
              caption="Created By"
              cssClass="text-left"
            ></dxi-column>
            <dxi-column
              dataField="updatedBy"
              caption="Updated By"
              cssClass="text-left"
            ></dxi-column>
            <dxi-column
              dataField="poNumber"
              caption="PO #"
              cssClass="text-left"
            ></dxi-column>
            <dxi-column
              dataField="customerCityName"
              caption="Customer City"
              cssClass="text-left"
            ></dxi-column>
            <dxi-column
              dataField="companyBranchName"
              caption="Branch Name"
              cssClass="text-left"
            ></dxi-column>
            <dxi-column
              dataField="soackTime"
              caption="Ack. Time"
              cssClass="text-left"
            ></dxi-column>
            <dxi-column
              dataField="soIssueTime"
              caption="Issue Time"
              cssClass="text-left"
            ></dxi-column>
            <dxi-column
              dataField="branchACKTime"
              caption="Branch Ack. Time"
              cssClass="text-left"
            ></dxi-column>
            <dxi-column
              dataField="coatingBrandName"
              caption="Coating"
              cssClass="text-left"
            ></dxi-column>
            <dxi-column
              dataField="plantName"
              caption="Plant Name"
              cssClass="text-left"
            ></dxi-column>
            <dxi-column
              dataField="productionOutTime"
              caption="Production Out Time"
              cssClass="text-left"
            ></dxi-column>
            <div *dxTemplate="let data of 'invoiceIdTemplate'">
              <!-- <a
                [href]="data.data.reportPath"
                matTooltip="Invoice Report #"
                target="_blank"
              >
                {{ data.data.invoiceId }}
              </a> -->
              {{ data.data.invoiceId }}
            </div>
            <div *dxTemplate="let data of 'currentStatusTemplate'">
              <div [ngStyle]="{ color: data.data.color }">
                <strong> {{ data.data.currentStatus }}</strong>
              </div>
            </div>
            <div *dxTemplate="let data of 'cellTemplate'">
              <a
                href="javascript:void(0)"
                *ngIf="accessGenerateReport(data.data.salesOrderTypeId)"
                (click)="!isGeneratingReport && generateReport(data.data.salesOrderNo, false)"
                matTooltip="{{ isGeneratingReport ? 'Generating...' : 'Download Report' }}"
                matTooltip="Download Report"
                class="cursor-pointer"
                 [style.pointerEvents]="isGeneratingReport ? 'none' : 'auto'"
                  [style.opacity]="isGeneratingReport ? 0.5 : 1"
              >
                <mat-icon color="primary">{{ isGeneratingReport ? 'hourglass_top' : 'cloud_download' }}</mat-icon>
              </a>
              <!-- <a
                *ngIf="data.data.salesOrderReportFile"
                [href]="data.data.salesOrderReportFile"
                matTooltip="Download Report"
                target="_blank"
              >
                <mat-icon color="primary">cloud_download</mat-icon>
              </a> -->
              <button
                class="w-25"
                mat-icon-button
                matTooltip="Edit Item"
                UserAccessibility="canModify"
                *ngIf="data.data.salesOrderTypeId == 1 && selectedCompanyBranchId == data.data.companyBranchId"
                [routerLink]="[
                  '/portal/sales/stock-order/edit/',
                  data.data.salesOrderNo
                ]"
                [queryParams]="{ salesOrderType: data.data.salesOrderTypeId }"
              >
                <mat-icon color="primary">edit</mat-icon>
              </button>
              <!-- <button
                class="w-25"
                mat-icon-button
                matTooltip="Edit Item"
                UserAccessibility="canModify"
                *ngIf="data.data.salesOrderTypeId == 4 && selectedCompanyBranchId == data.data.companyBranchId"
                [routerLink]="[
                  '/portal/sales/stock-sale-order/spt-order/edit/',
                  data.data.salesOrderNo
                ]"
                [queryParams]="{ salesOrderType: data.data.salesOrderTypeId }"
              >
                <mat-icon color="primary">edit</mat-icon>
              </button> -->
              <button
                class="w-25"
                mat-icon-button
                matTooltip="Edit Item"
                UserAccessibility="canModify"
                *ngIf="data.data.salesOrderTypeId == 3 && selectedCompanyBranchId == data.data.companyBranchId"
                [routerLink]="[
                  '/portal/sales/fitting-order/edit/',
                  data.data.salesOrderNo
                ]"
                [queryParams]="{ salesOrderType: data.data.salesOrderTypeId }"
              >
                <mat-icon color="primary">edit</mat-icon>
              </button>
              <button
                class="w-25"
                mat-icon-button
                matTooltip="Edit Item"
                *ngIf="data.data.salesOrderTypeId == 5 && selectedCompanyBranchId == data.data.companyBranchId"
                [routerLink]="[
                  '/portal/sales/job-order/edit/',
                  data.data.salesOrderNo
                ]"
                [queryParams]="{ salesOrderType: data.data.salesOrderTypeId }"
              >
                <mat-icon color="primary">edit</mat-icon>
              </button>
              <!-- <button
                class="w-25"
                mat-icon-button
                matTooltip="Edit Item"
                *ngIf="data.data.salesOrderTypeId == 2 && selectedCompanyBranchId == data.data.companyBranchId"
                UserAccessibility="canModify"
                [routerLink]="[
                  '/portal/sales/stock-sale-order/bulk-order/edit/',
                  data.data.salesOrderNo
                ]"
                [queryParams]="{ salesOrderType: data.data.salesOrderTypeId }"
              >
                <mat-icon color="primary">edit</mat-icon>
              </button> -->
              <!-- <button
                class="w-25"
                mat-icon-button
                matTooltip="Edit Item"
                *ngIf="data.data.salesOrderTypeId == 7 && selectedCompanyBranchId == data.data.companyBranchId"
                UserAccessibility="canModify"
                [routerLink]="[
                  '/portal/sales/stock-sale-order/miscellaneous-order/edit/',
                  data.data.salesOrderNo
                ]"
                [queryParams]="{ salesOrderType: data.data.salesOrderTypeId }"
              >
                <mat-icon color="primary">edit</mat-icon>
              </button> -->

              <!-- <button
                class="w-25"
                type="button"
                mat-icon-button
                matTooltip="Delete Item"
                *ngIf="data.data.salesOrderTypeId != 6"
                [swal]="deleteSwal"
              >
                <mat-icon color="warn">delete</mat-icon>
              </button>
              <button
                type="button"
                mat-icon-button
                matTooltip="Delete Item"
                *ngIf="data.data.salesOrderTypeId == 6"
                [swal]="deleteSwal"
              >
                <mat-icon color="warn">delete</mat-icon>
              </button>
              <swal
                #deleteSwal
                title="Are you sure want to delete ?"
                text="This cannot be undone"
                type="question"
                [showCancelButton]="true"
                [focusCancel]="true"
                (confirm)="deleteSalesOrder(data.data.salesOrderNo)"
              >
              </swal> -->
            </div>
           
            <div *dxTemplate="let data of 'salesOrderNoTemplate'">
              <!-- (click)="generateReport(data.data.salesOrderNo, false)" -->
              <!-- <a
                href="javascript:void(0)"
                matTooltip="Sales Order #"
                >
                {{ data.data.salesOrderNo }}
              </a> -->
              {{ data.data.salesOrderNo }}
            </div>

            <div class="employee dx-row" *dxTemplate="let d of 'sphTemplate'">
              <div class="main-row">
                <div class="text-center">
                  <div
                    *ngIf="
                      (d.data.sph && d.data.sph) ||
                      (d.data.sph == 0 && d.data.sph)
                    "
                  >
                    <mat-chip>{{ d.data.sph | number: "1.2-2" }}</mat-chip>
                  </div>
                </div>
              </div>
            </div>
            <div class="employee dx-row" *dxTemplate="let d of 'cylTemplate'">
              <div class="main-row">
                <div class="text-center">
                  <div
                    *ngIf="
                      (d.data.cyl && d.data.cyl) ||
                      (d.data.cyl == 0 && d.data.cyl)
                    "
                  >
                    <mat-chip>{{ d.data.cyl | number: "1.2-2" }}</mat-chip>
                  </div>
                </div>
              </div>
            </div>
            <div class="employee dx-row" *dxTemplate="let d of 'axisTemplate'">
              <div class="main-row">
                <div class="text-center">
                  <div
                    *ngIf="
                      (d.data.axis && d.data.axis) ||
                      (d.data.axis == 0 && d.data.axis)
                    "
                  >
                    <mat-chip>{{ d.data.axis }}</mat-chip>
                  </div>
                </div>
              </div>
            </div>
            <div class="employee dx-row" *dxTemplate="let d of 'addTemplate'">
              <div class="main-row">
                <div class="text-center">
                  <div
                    *ngIf="
                      (d.data.add && d.data.add) ||
                      (d.data.add == 0 && d.data.add)
                    "
                  >
                    <mat-chip>{{ d.data.add | number: "1.2-2" }}</mat-chip>
                  </div>
                </div>
              </div>
            </div>
            <div *dxTemplate="let data of 'salesReturnIdTemplate'">
              <!--  (click)="generateReport(data.data.salesReturnId, false)" -->
              <a
                href="javascript:void(0)"
                matTooltip="Sales Return #"
               >
                {{ data.data.salesReturnId }}
              </a>
            </div>
            <dxo-summary [recalculateWhileEditing]="true">
              <dxi-total-item
                column="services"
                alignment="right"
                [customizeText]="customizeText"
                summaryType="sum"
              >
              </dxi-total-item>
              <dxi-total-item
                column="totalAmount"
                alignment="center"
                [customizeText]="customizeTotal"
                summaryType="sum"
              >
              </dxi-total-item>
              <dxi-total-item
                column="oQty"
                alignment="center"
                [customizeText]="customizeTotal"
                summaryType="sum"
              >
              </dxi-total-item>
              <dxi-total-item
                column="iQty"
                alignment="center"
                [customizeText]="customizeTotal"
                summaryType="sum"
              >
              </dxi-total-item>
            </dxo-summary>
          </dx-data-grid>
        </div>
      </div>
    </div>
  </div>
</div>
<swal #saveSwal></swal>
